import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';
import ReactPhoneInput from 'react-phone-input-2';

import { InputRef } from 'components';
import 'react-phone-input-2/lib/material.css';
import styles from './PhoneInputstyles.module.scss';

const PhoneInputField = (props) => {
  const {
    label = 'Phone',
    error,
    helperText,
    onBlur,
    required = true,
    value = '',
    country = 'us',
    ...rest
  } = props;

  let inputValue = value || '1';

  const enableLongNumbers = country === 'gb';

  inputValue = value;

  return (
    <TextField
      fullWidth
      required={required}
      label={label}
      helperText={helperText}
      error={error}
      onBlur={onBlur}
      variant="outlined"
      disabled={rest?.disabled || false}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        inputComponent: InputRef,
        inputProps: {
          value: inputValue,
          key: country,
          placeholder: '',
          component: ReactPhoneInput,
          specialLabel: '',
          country: country,
          onlyCountries: [country],
          containerClass: styles.containers,
          inputClass: styles.phoneInput,
          countryCodeEditable: false,
          disableDropdown: true,
          enableAreaCodes: false,
          enableLongNumbers,
          ...rest,
          inputProps: {
            id: rest?.id,
            name: rest?.name,
            'data-testid': `${rest?.id || 'phone-input-field'}`,
          },
        },
      }}
    />
  );
};

PhoneInputField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  isValid: PropTypes.bool,
  countryCodeEditable: PropTypes.bool,
  disabled: PropTypes.bool,
  country: PropTypes.string,
  onlyCountries: PropTypes.array,
};

export default memo(PhoneInputField);